import { useState } from "react";
import { api, ApiError } from "../api/client";
import { trackEvent } from "../telemetry";

export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    const startedAt = performance.now();
    try {
      await api.login(email, password);
      trackEvent("login_succeeded", {
        email,
        duration_ms: Math.round(performance.now() - startedAt),
      });
      onLoggedIn();
    } catch (exc) {
      trackEvent("login_failed", {
        status: exc instanceof ApiError ? exc.status : "unknown",
        duration_ms: Math.round(performance.now() - startedAt),
      });
      if (exc instanceof ApiError) setError(exc.detail);
      else setError(String(exc));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ maxWidth: 380, margin: "120px auto", padding: 24 }}>
      <h1 style={{ fontSize: 22, marginBottom: 6 }}>Ensovia</h1>
      <p style={{ color: "#6b7378", marginBottom: 24 }}>Sign in to continue.</p>
      <form onSubmit={submit}>
        <label style={{ display: "block", marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Email</div>
          <input
            className="field"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
          />
        </label>
        <label style={{ display: "block", marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Password</div>
          <input
            className="field"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>
        {error && (
          <div style={{ color: "#b53a2c", fontSize: 13, marginBottom: 12 }}>{error}</div>
        )}
        <button className="btn btn-primary" type="submit" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
